import { render, staticRenderFns } from "./PersonChip.vue?vue&type=template&id=5581cda1"
import script from "./PersonChip.vue?vue&type=script&lang=js"
export * from "./PersonChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports